<template>
	<div>
		<div v-for="fieldDef in fieldsDefinitionsForParamsDispatcher" :key="fieldDef.id">
			<ParamDispatcherDataProvider
				:param="fieldDef"
				:node="node"
				@update-input-field="updateInputField"
				@update-input-field-label="updateInputFieldLabel"
				@update-input-fallback="updateInputFallback"
			/>
		</div>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';

import ParamDispatcherDataProvider from '../../BlockEditorParams/ParamDispatcherDataProvider';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
import { DATA_TYPES, TYPES_CONF_MAP } from '../helpers/data-types.const';

export default {
	name: 'SubFlowParamsForm',
	components: {
		ParamDispatcherDataProvider,
	},
	props: {
		fieldsDefinitions: { type: Array },
		node: { type: Object },
	},
	data() {
		return {
			DATA_TYPES: [...DATA_TYPES],
		};
	},
	computed: {
		paramsMapLocal: {
			get() {
				return this.node.params_map;
			},
			set(v) {
				this.$emit('updateSubflowParams', { ...this.node.params_map, ...v });
			},
		},
		fieldsDefinitionsForParamsDispatcher() {
			return this.fieldsDefinitions?.map((r) => ({ ...r, key: r.uuid, required: r.is_required, ...TYPES_CONF_MAP[r.type] })) || []; // so InsertDataField can work
		},
		isValidForm() {
			return this.fieldsDefinitionsForParamsDispatcher.every(
				(fd) => !fd.is_required || (fd.is_required && !isNullOrUndefinedOrEmpty(this.paramsMapLocal[fd.uuid]))
			);
		},
	},
	methods: {
		updateInputField(payload) {
			const { map, label, param } = payload;
			// const { map, label, param, preventUpdateEditNode } = payload;
			this.debouncedOnChange(param.uuid, map.value);
			// this.$emit('update-block-param', { ...map, reloadDynamic: param?.dynamic, preventUpdateEditNode });

			// TODO - make sure we dont need this anymore,
			// as this is not used and updateInputfieldLabel is being called directly when needed
			if (label) {
				this.updateInputFieldLabel({ label });
			}
		},
		updateInputFieldLabel(payload) {
			const { label, preventUpdateEditNode } = payload;
			this.$emit('update-block-param-label', { ...label, preventUpdateEditNode });
		},
		updateInputFallback(payload) {
			if (payload) {
				this.$emit('update-params-fallback', payload);
			}
		},
		onChange(id, newV) {
			this.paramsMapLocal = { [id]: newV };
			this.$nextTick(() => {
				this.$emit('setIsValid', this.isValidForm);
			});
		},
	},
	created() {
		this.debouncedOnChange = debounce(this.onChange, 300);
	},
};
</script>

<style scoped lang="scss">
.required-label {
	padding: 0 2px;
	color: var(--error-border-color);
	background-color: #f8edf2;
	border-radius: 2px;
}
</style>
